import { MerchFlowCoreRange } from "../merchandise";

export const RoutePostMerchflowsImportPlanograms = "/merchflows/import-planograms";

export interface PayloadFormPostMerchflowsImportPlanograms {
  planogram_file: File;
  merchflow_name: string;
  notes?: string;
  go_live_date: string;
  core_range_option: MerchFlowCoreRange;
  deactivation_date?: string | null;
}

export type PayloadPostMerchflowsImportPlanograms = FormData;

export interface ResponsePostMerchflowsImportPlanograms {
  merchflow_id: number;
  merchflow_name: string;
  total_stores: number;
  successful_stores: number;
  failed_stores: number;
  store_results: Array<{
    store_code: string;
    status: "SUCCESS" | "ERROR";
    error?: string;
  }>;
}
